<template>
  <form v-on:submit.prevent="submit">
    <div class="input-group">
      <input v-model="newMessage" type="text" placeholder="Invia una domanda..." :disabled="inputDisabled"
             class="form-control">
      <span class="input-group-append">
        <input :disabled="inputDisabled" type="submit" class="btn btn-primary" value="Invia"/>
      </span>
    </div>
  </form>
</template>

<script>
  const axios = require('axios');
  const moment = require('moment');

  export default {
    name: "Chat",
    data() {
      return {
        messages: [],
        newMessage: "",
        inputDisabled: false
      }
    },
    props: {
      eventId: String
    },
    methods: {
      submit() {
        if (this.newMessage === "") return;

        this.inputDisabled = true;
        axios.post(`/send_message`, {message: this.newMessage})
          .then(function () {
            this.newMessage = "";
            this.inputDisabled = false;
          }.bind(this));
      }
    },
  }
</script>

<style scoped>
  .chat {
    max-height: 350px;
  }
</style>
